import { render, staticRenderFns } from "./CompareFormulaVersion.vue?vue&type=template&id=056637ff&scoped=true&"
import script from "./CompareFormulaVersion.vue?vue&type=script&lang=js&"
export * from "./CompareFormulaVersion.vue?vue&type=script&lang=js&"
import style0 from "./CompareFormulaVersion.vue?vue&type=style&index=0&id=056637ff&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056637ff",
  null
  
)

export default component.exports